import { render, staticRenderFns } from "./SuggestedChannels.vue?vue&type=template&id=9072ac3e&scoped=true&"
import script from "./SuggestedChannels.vue?vue&type=script&lang=ts&"
export * from "./SuggestedChannels.vue?vue&type=script&lang=ts&"
import style0 from "./SuggestedChannels.vue?vue&type=style&index=0&id=9072ac3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9072ac3e",
  null
  
)

export default component.exports